"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const CompositionViewHeader_vue_1 = __importDefault(require("./components/CompositionViewHeader.vue"));
const CompositionViewMain_vue_1 = __importDefault(require("./components/CompositionViewMain.vue"));
const ControllerRateCompositorTool_1 = __importDefault(require("./abstract/controllers/ControllerRateCompositorTool"));
const ModelCompositorCategory_1 = __importDefault(require("./abstract/models/ModelCompositorCategory"));
const ModalErrorControl_vue_1 = __importDefault(require("./components/Modals/ModalErrorControl.vue"));
let CompositionView = class CompositionView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.currentCategory = '';
        this.categoriesByOrder = [];
        this.currentCropId = -1;
        this.isTooltipSuccessCreated = false;
        this.isDeployModalFailedCall = false;
        this.isMounted = false;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get proposalId() {
        const url = new URL(window.location.href);
        const proposalId = url.searchParams.get('proposal');
        return parseInt(proposalId);
    }
    get lastGisAreaCreated() {
        const currentGisArea = this.categoriesFilterByCategory(this.currentCategory);
        return currentGisArea.gis_areas[currentGisArea.gis_areas.length - 1].areaName;
    }
    async mounted() {
        this.controllerCompositionTool = new ControllerRateCompositorTool_1.default(this.proposalId);
        await this.callData();
        if (this.controllerCompositionTool.isFailedCall) {
            this.deployModalFailedCall();
        }
        else {
            this.orderCategories();
            this.getcurrentCategory();
        }
        this.isMounted = true;
    }
    get failedCallData() {
        if (this.isMounted)
            return this.controllerCompositionTool.errorModel;
    }
    async callData() {
        await this.controllerCompositionTool.callDataCompositorTool();
        this.orderCategories();
    }
    async createProject() {
        await this.callData();
        this.deployToast();
    }
    dismissToast() {
        this.isTooltipSuccessCreated = false;
    }
    deployToast() {
        this.isTooltipSuccessCreated = true;
    }
    dismissModalFailedCall() {
        this.isDeployModalFailedCall = false;
    }
    deployModalFailedCall() {
        this.isDeployModalFailedCall = true;
    }
    getcurrentCategory() {
        this.currentCategory = this.controllerCompositionTool.currentCategory.category;
    }
    updateCurrentCategory(currentCategory) {
        this.currentCategory = currentCategory;
    }
    updateCurrentCrop(cropId) {
        this.currentCropId = cropId;
    }
    orderCategories() {
        if (this.controllerCompositionTool) {
            this.categoriesByOrder = this.controllerCompositionTool.categoriesOrder;
        }
    }
    categoriesFilterByCategory(category) {
        if (this.controllerCompositionTool && category) {
            return new ModelCompositorCategory_1.default(this.controllerCompositionTool.filterCategorysByCategory(category), false);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], CompositionView.prototype, "theme", void 0);
CompositionView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            CompositionViewHeader: CompositionViewHeader_vue_1.default,
            CompositionViewMain: CompositionViewMain_vue_1.default,
            Toasts: bmk_ui_framework_1.Toasts,
            CheckDiamondIcon: bmk_ui_framework_1.CheckDiamondIcon,
            ModalErrorControl: ModalErrorControl_vue_1.default,
        },
    })
], CompositionView);
exports.default = CompositionView;
